// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Xoso","content":"Consent_content__1Rfct","footer":"Consent_footer__UzPeS"};